<template>
  <div class="content">
    <div class="realName" @click="clickUserName">当前用户：{{realName}}</div>
    <div class="logout" @click="logout">退出</div>
  </div>
</template>
<style scoped lang="scss">
  .content {
    display: flex;
    font-size: 12px;

    .realName {
      cursor: pointer;
    }
    .logout {
      margin-left: 10px;
      color: #30c0cd;
      cursor: pointer;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/account-info/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/account-info/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/account-info/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-account-info')
  export default {
    name: 'base-account-info', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-account-info': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>